import Contact from './contact'
import Location from './location'
import Username from './username'

/**
 * @author  Peter Collins /github.com/chimdipetercollins
 * @alias   User
 */

// This class initializes the logic for managing user data

class User {
    /**
     * @param   type: String
     * @param   timestamp: String
     * @param   verification: String
     */
    constructor(object) {
        this._typeof = 'instarent user'

        if (object) {
            this._type = !object.type ? 'person' : object.type // person or business
            this._timestamp = object.timestamp

            this._verification = object.verification
        }

        this._posts = new Map()
        this._rentals = new Map()
        this._wishlist = new Map()

        this._contact = new Contact()
        this._location = new Location()
        this._username = new Username()
    }

    // getters

    get businessName() {
        return this._username.businessname
    }

    get firstName() {
        return this._username.firstname
    }

    get fullName() {
        return this._username.fullname
    }

    get middleName() {
        return this._username.middlename
    }

    get lastName() {
        return this._username.lastname
    }

    get id() { // user id will be used as a ref to retrieve {images, account details, card details, etc}
        let name
        let value

        this.type === 'person'
        ?   name = this.fullName
        :   name = this.businessName

        value = name + this.timeStamp 

        return value
    }

    get type() {
        return this._type
    }

    get timestamp() {
        return this._timestamp
    }

    get verification() {
        return this._verification
    }

    get posts() {
        return this._posts
    }

    get rentals() {
        return this._rentals
    }

    get wishlist() {
        return this._wishlist
    }

    get contact() {
        let value

        this._contact.typeof === 'contact'
        ?   value = this._contact
        :   value = 'invalid'

        return value
    }

    get location() {
        let value

        this.location.typeof === 'location'
        ?   value = this._location
        :   value = 'invalid'

        return value
    }

    get username() {
        let value

        this.username.typeof === 'username'
        ?   value = this._username
        :   value = 'invalid'
        
        return value
    }

    get typeof() {
        return this._typeof
    }


    // setters

    /**
     * @param {String} newId
     */
    set setId(newId) {
        this._id = newId
    }

    /**
     * @param {String} newType
     */
    set setType(newType) {
        this._type = newType
    }

    /**
     * @param {String} newTime
     */
    set setTimestamp(newTime) {
        this._timestamp = newTime
    }

    /**
     * @param {Object} newId
     */
    set setVerification(newId) {
        this._verification = newId
    }
    
    /**
     * @param {{ id: String; }} newPost
     */
    set addPost(newPost) {
        this._posts.set(newPost.id, newPost)
    }

    /**
     * @param {String} itemId
     */
    set removePost(itemId) {
        for (let key of this._posts.keys()) {
            if (itemId === key && !this._posts.get(key).leased) {
                this._posts.delete(key)
            }
        }
    }
    
    /**
     * @param {{ id: String; }} newRental
     */
    set addRental(newRental) {
        this._rentals.set(newRental.id, newRental)
    }

    /**
     * @param {{ id: String; }} newItem
     */
    set addToWishlist(newItem) {
        this._wishlist.set(newItem.id, newItem)
    }

    /**
     * @param {String} itemId
     */
    set removeFromWishlist(itemId) {
        for (let key of this._wishlist.keys()) {
            if (itemId === key){
                this._wishlist.delete(key)
            }
        }
    }
}

export default User
